import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CadminCompaniesAx from 'app/actions/company-admin/companies';
import NumberInput       from 'app/components/common/number-input';
import Modal             from 'app/components/common/modal';
import StandardSelect    from 'app/components/common/standard-select';
import {
  GracePeriodUnits,
}                        from 'app/constants';

const gpOpts = Object.values(GracePeriodUnits).map((unit) => {
  return {label: unit, value: unit};
});

class ModalGracePeriod extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      unit: null,
      value: null,
      isSaving: false,
    };

    this.onChangeValue = this.onChangeValue.bind(this);
    this.onSelectUnit = this.onSelectUnit.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
  }

  get unit() {
    if (this.state.unit != null) return this.state.unit;
    return this.props.company.gracePeriodUnit;
  }

  get value() {
    if (this.state.value != null) return this.state.value;
    return this.props.company.gracePeriodValue;
  }

  get attrs() {
    return {
      gracePeriodValue: this.value,
      gracePeriodUnit: this.unit,
    };
  }

  get isSame() {
    if (this.unit !== this.props.company.gracePeriodUnit) return false;
    if (this.value !== this.props.company.gracePeriodValue) return false;
    return true;
  }

  get canSubmit() {
    return this.value >= 0;
  }

  get btnDisabled() {
    if (this.isSame) return true;
    if (this.isSaving) return true;
    if (!this.canSubmit) return true;
    return false;
  }

  get btnLabel() {
    return this.isSaving ? 'Saving...' : 'Save';
  }

  onChangeValue(value) {
    this.setState({value});
  }

  onSelectUnit(unit) {
    this.setState({unit: unit});
  }

  onClickSave() {
    this.setState({isSaving: true});
    this.props.save(this.props.company.id, this.attrs).then(() => {
      this.setState({isSaving: false});
      this.props.onClose();
    });
  }

  render() {
    return (
      <Modal onClose={this.props.onClose} className="bform">
        <h1 className="bform-h1">Offline Donation Grace Period</h1>

        <label className="bform-h3">Duration</label>
        <div className="_flex _justify-start">
          <NumberInput value={this.value} onChange={this.onChangeValue} />
          <StandardSelect className="_flex-1" options={gpOpts} onSelect={this.onSelectUnit} value={this.unit} />
        </div>

        <div className="bform-actions">
          <div className="bform-actions-left" />
          <button onClick={this.onClickSave} className="btn blue" disabled={this.btnDisabled}>{this.btnLabel}</button>
        </div>
        
      </Modal>
    );
  }
}

ModalGracePeriod.propTypes = {
  company: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

const stateToProps = (state) => ({});
const dispatchToProps = (dispatch) => ({
  save: (companyId, attrs) => dispatch(CadminCompaniesAx.update(companyId, attrs)),
});

export default connect(stateToProps, dispatchToProps)(ModalGracePeriod);
